import { IconButton, Typography, Box, useTheme } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import Avatar from './Avatar';

const CareTeamMemberItem = ({ option, handleRemove }) => {

  const theme = useTheme()
  const title = option?.firstName
    ? `${option?.firstName} ${option?.lastName}`
    : `${option?.name?.firstName} ${option?.name?.lastName}`;

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      marginBottom={'5px'}
    >
      <Box display="flex" flexDirection="row" alignItems="center">
        <Avatar
          src={option?.photoUrl}
          size="medium"
          style={{ marginRight: 20 }}
        />
        <Box display="flex" flexDirection="column">
          <Typography>{title}</Typography>
          {option?.role && (
            <Typography style={{ fontSize: 13, color: theme.palette.colors.gray400 }}>
              {option?.role}
            </Typography>
          )}
        </Box>
      </Box>

      {handleRemove && (
        <IconButton
          dataId={'remove-selected-care-team-member-button'}
          size="small"
          onClick={() => handleRemove(option?.id)}
        >
          <CloseIcon style={{ height: 16, width: 16, color: theme.palette.colors.red100 }} />
        </IconButton>
      )}
    </Box>
  );
};

export default CareTeamMemberItem;
